import { colors } from "design"

export const explorerTableStyle = {
  whiteSpace: "nowrap",
  th: {
    padding: "20px 36px",
  },
  td: {
    padding: "14px 36px",
    color: colors.grey500,
    fontSize: 14,
  },
  tbody: {
    tr: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: colors.grey300,
      },
      "&:nth-of-type(even):not(:hover)": {
        backgroundColor: colors.cream,
      },
      "&:nth-of-type(odd):not(:hover)": {
        backgroundColor: colors.darkCream,
      },
    },
  },
}

export const tableFormStyle = {
  whiteSpace: "nowrap",
  th: {
    padding: "20px 36px",
  },
  td: {
    padding: "10px 36px",
    color: colors.grey500,
    fontSize: 14,
  },
  tbody: {
    tr: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: colors.grey300,
      },
      "&:nth-of-type(even):not(:hover)": {
        backgroundColor: colors.grey50,
      },
      "&:nth-of-type(odd):not(:hover)": {
        backgroundColor: colors.grey,
      },
      '&[aria-selected="true"]': {
        backgroundColor: 'rgba(66, 133, 244, 0.1294117647) !important'
      },
    },
  },
  '.empty-table-cell':{
    height:36
  }
}